'use client';

import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/react';

import TabFilterItem from '@/app/(football)/[team]/_components/common/TabFilterItem';

interface EditionFilterProps {
  editions: string[];
  selected: string;
  onSelect: (edition: string) => void;
  isLoading: boolean;
}

export default function EditionFilter({ editions, selected, onSelect, isLoading }: EditionFilterProps) {
  if (isLoading) {
    return (
      <div className="flex flex-1 gap-2">
        {[49, 60].map((w, i) => (
          <div key={i} className="animate-pulse rounded-full bg-white/10" style={{ width: w, height: 18 }} />
        ))}
      </div>
    );
  }

  return (
    <div className="relative flex-1 overflow-hidden">
      <Swiper slidesPerView="auto" spaceBetween={12} className="w-full">
        {editions.map((edition) => (
          <SwiperSlide key={edition} style={{ width: 'auto' }}>
            <TabFilterItem label={edition} isSelected={selected === edition} onClick={() => onSelect(edition)} />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Right gradient overlay */}
      <div
        className="pointer-events-none absolute top-0 right-0 z-10 h-full w-[40px]"
        style={{
          background: 'linear-gradient(to right, transparent, var(--color-card-deco-filter-fade))',
        }}
      />
    </div>
  );
}
